import { useQuery } from "@tanstack/react-query";
import { hubCohort } from "@/lib/api";

export default function Cohort() {
  const { data = [], isLoading } = useQuery({ queryKey: ["hub-cohort"], queryFn: hubCohort });
  return (
    <div data-testid="hub-cohort">
      <p className="cv-kicker">Cohort materials</p>
      <h1 className="cv-display text-3xl mt-4">Decks, recordings, worksheets.</h1>
      {isLoading ? (
        <p className="cv-body text-[#9A938A] mt-8">Loading...</p>
      ) : data.length === 0 ? (
        <p className="cv-body text-sm text-[#9A938A] mt-8">
          Cohort materials appear here when you join a workshop or accelerator cohort.
        </p>
      ) : (
        <div className="mt-8 space-y-3">
          {data.map((m) => (
            <div key={m.id} data-testid="cohort-item" className="border border-[rgba(28,27,25,0.14)] rounded-[14px] p-5 flex items-center justify-between">
              <div>
                <h3 className="cv-h2 text-sm">{m.title}</h3>
                <p className="cv-body text-xs text-[#9A938A] mt-1">{m.cohort} · {m.kind}</p>
              </div>
              {m.url && <a href={m.url} target="_blank" rel="noopener noreferrer" className="cv-link">Open</a>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
